import { MARKET } from '@nandosaus/constants';
import PropTypes from 'prop-types';

import { Box } from '../grid';
import { Button } from '../button';
import { H3, P } from '../typography';
import { Image } from '../image';
import { Modal } from '../modal';
import { navigation } from '../../constants';
import { useMarket } from '../../hooks/use-market';

const LOSE_NO_SPINS_LEFT_IMAGE = {
  [MARKET.AUSTRALIA]: '/static/images/spin-to-win/lose-no-spins-left-au.jpg',
  [MARKET.NEW_ZEALAND]: '/static/images/spin-to-win/lose-no-spins-left-nz.jpg',
};

const LoseModal = ({ entriesAvailable, userCanEnter, onClose, onSpin }) => {
  const market = useMarket();

  return (
    <Modal
      open
      handleClose={onClose}
      isDividerHidden
      buttons={{
        primary: userCanEnter ? (
          <Button onClick={onSpin} isFullWidth>
            Spin Again ({entriesAvailable})
          </Button>
        ) : (
          <Button href={navigation.MENU}>Back to menu</Button>
        ),
        secondary: userCanEnter ? (
          <Button variant="secondary" href={navigation.MENU} isFullWidth>
            Back to menu
          </Button>
        ) : (
          undefined
        ),
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" px="2.5rem">
        <H3 mb="1.5rem" textAlign="center">
          Ahhh so close!
        </H3>
        <Image
          mb={1}
          src={userCanEnter ? '/static/images/spin-to-win/lose.png' : LOSE_NO_SPINS_LEFT_IMAGE[market]}
          width="456"
          height="190"
          alt={userCanEnter ? 'Spin Again' : 'Purchase eligible product to get more spins.'}
        />
        <P mb="0.5rem" variant={2} fontWeight="bold">
          Unfortunately you didn’t win this time, but there are still a ton of prizes up for grabs. Keep trying, as
          there is a 1 in 4 chance to win.
        </P>
      </Box>
    </Modal>
  );
};

LoseModal.propTypes = {
  entriesAvailable: PropTypes.number.isRequired,
  userCanEnter: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSpin: PropTypes.func.isRequired,
};

export { LoseModal };
